/* src/app/order-summary/order-summary.component.scss */
tfoot tr:last-child {
  background-color: #DCDCDC;
}
figure {
  padding: 0.5em;
}
/*# sourceMappingURL=order-summary.component.css.map */
